export enum UserTypeConstants {
  USER_TYPE_SSO = 'sso',
  USER_TYPE_SSO_INACTIVE = 'sso_inactive',
  USER_TYPE_ORACLE = 'oracle',
  USER_TYPE_OFFLINE = 'offline',
  USER_TYPE_ACCOUNT_LOCKED = 'account_locked',
}
